module.exports = "/packs/images/mission-values/mission-hero-mobile@2x-974892106ec5736ea4217d1e5c25eaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mission-values/mission-hero-mobile@2x.jpg
// module id = 1778
// module chunks = 0